<template lang="pug">
  el-tabs(
    type="border-card"
    tab-position="top"
    @tab-click="tabClick"
    id="tabs-reurb"
    :value="selectedTab"
  )
    el-tab-pane(:label="LABELS.DIARIO" name="DIARIO")
    el-tab-pane(:label="LABELS.MENSAL" name="MENSAL")
    el-tab-pane(:label="LABELS.ANUAL" name="ANUAL")
</template>

<script>

import GraficoRelatoriosPeriodo from './graficos/GraficoRelatoriosPeriodo'

const DIARIO = 'Diário'
const MENSAL = 'Mensal'
const ANUAL = 'Anual'

export default {
  props: {
    selectedTab: {
      type: String,
      required: true
    }
  },
  components: {
    GraficoRelatoriosPeriodo
  },

  data () {
    return {
      LABELS: {
        DIARIO,
        MENSAL,
        ANUAL
      }
    }
  },

  methods: {
    tabClick (tab) {
      let filtro

      if (tab.label === 'Diário') {
        filtro = {tipoPeriodo: 'DIARIO'}
      } else if (tab.label === 'Mensal') {
        filtro = {tipoPeriodo: 'MENSAL'}
      } else {
        filtro = {tipoPeriodo: 'ANUAL'}
      }

      this.$emit('search', filtro)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.el-tab-pane {
  min-height: 0px;
}

.el-tabs--border-card {
  margin-bottom: 20px;
}

.el-tabs {
  border-radius: 15px 15px 0 0;
  border-color: transparent;
  overflow: hidden;
}

#tabs-reurb >>> .el-tabs__content {
  padding: 0 !important;
}

#tabs-reurb {
  -webkit-box-shadow: none;
  box-shadow: none;
}

</style>



// WEBPACK FOOTER //
// src/screens/relatorios_reurb/components/TabsPeriodo.vue